import { AssetType, AssetPurchaseType } from "@interfaces/rest";

export const getLabelFileAgreementField = (
  typeId: AssetType | "",
  purchaseTypeId: AssetPurchaseType | "",
) => {
  if (typeId === "vehicle" && purchaseTypeId === "hire_purchase") {
    return "HP Agreement";
  } else if (
    typeId === "vehicle" &&
    purchaseTypeId === "personal_contract_purchase"
  ) {
    return "PCP Agreement";
  } else if (typeId === "vehicle" && purchaseTypeId === "loan") {
    return "Loan Agreement";
  } else if (typeId === "rental_property" && purchaseTypeId !== "lease") {
    return "Completion Statement";
  } else if (typeId === "other" && purchaseTypeId === "finance") {
    return "Finance Agreement";
  } else {
    return "Agreement";
  }
};
